import { OnInit, Component } from "@angular/core";
@Component({
  selector: "app-tools",
  templateUrl: "./tools.component.html",
  standalone: false
})
export class ToolsComponent implements OnInit {

  constructor() { }

  ngOnInit() {
  }

}
